export default __webpack_public_path__ + "media/images/pig_and_bird_ui_plane-e8470c2993b5ab8c9353ccb8d86532a2.svg";